import Grid from '@material-ui/core/Grid';
import React from 'react';
import PropTypes from 'prop-types';
import useStyles from 'isomorphic-style-loader/useStyles';
import Link from '../../../components/Link';
import s from './MoreThemes.css';

export default function MoreThemes({ moreThemes }) {
	useStyles(s);

	return (
		<div
			style={{
				backgroundImage: 'linear-gradient(180deg, #f3f4f8, #fff)',
				textAlign: 'center',
				padding: '10px 0 20px 0',
			}}
		>
			<h2>More themes</h2>

			<Grid
				container
				alignContent="center"
				alignItems="center"
				justify="center"
				style={{ marginBottom: 20 }}
			>
				{moreThemes.map(theme => (
					<Grid item key={theme.id}>
						<div className={s.card}>
							<a href={`/theme/${theme.id}`}>
								<img
									src={`/screenshots/400/${theme.id}-${theme.workspace}.jpg`}
									alt={theme.title || 'New tab theme'}
									width={200}
									loading="lazy"
								/>
							</a>

							<h4 className={s.themeTitle}>
								<a href={`/theme/${theme.id}`}>
									{theme.title ? theme.title : 'No title'}
								</a>
							</h4>
						</div>
					</Grid>
				))}
			</Grid>

			<Link to="/themes">Browse all new tab themes...</Link>
		</div>
	);
}

MoreThemes.propTypes = {
	moreThemes: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.string.isRequired,
			title: PropTypes.string,
			workspace: PropTypes.number,
		}),
	).isRequired,
};
